import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaExclamationTriangle,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import SecurityChartsContainer from '../Common/SecurityChartsContainer';
import OcurrencesWrapper from './Ocurrences';
import SpotsWrapper from './Spots';
import RankingsWrapper from './Rankings';
import PoliceWrapper from './Police';
import ProfileWrapper from './Profile';



const PoliceInterventionDeaths = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Ocorrências',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Perfil',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/profile`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Polícia',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/police`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Locais',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        },
        {
            title: 'Rankings',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        },
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`]:'Resultados Gerais das Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/profile`]: 'Resultados dos Indicadores do Perfil',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/police`]: 'Resultados dos Indicadores da Polícia',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`]: 'Resultados dos Indicadores de Locais',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`]: 'Rankings'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <SecurityChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="ocurrences" replace />}
                        />
                        <Route
                            path="ocurrences"
                            element={<OcurrencesWrapper />}
                        />
                        <Route
                            path="profile"
                            element={<ProfileWrapper />}
                        />
                        <Route
                            path="police"
                            element={<PoliceWrapper />}
                        />
                        <Route
                            path="spots"
                            element={<SpotsWrapper />}
                        />
                        <Route
                            path="rankings"
                            element={<RankingsWrapper />}
                        />
                    </Routes>
                </SecurityChartsContainer>
            </Box>
        </Box>
    );
};

export default PoliceInterventionDeaths;
